import _drop from "lodash/drop";
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-5355bc94"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "video-list"
};
var _hoisted_2 = {
  class: "video-list-name"
};
var _hoisted_3 = {
  key: 0
};
var _hoisted_4 = {
  class: "video-box"
};
import { useStore } from 'vuex';
import { useLang } from '../../../hooks/lang';
import VideoBox from './video-box.vue';
export default {
  props: {
    isSearch: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    name: {
      type: String,
      default: ''
    },
    query: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useLang = useLang(),
      $t = _useLang.$t;
    var isShowMore = ref(false);
    var handleShowMore = function handleShowMore() {
      isShowMore.value = !isShowMore.value;
    };
    var showList = computed(function () {
      return props.list.slice(0, 6);
    });
    var hideList = computed(function () {
      return _drop(props.list, 6);
    });
    var showMoreText = computed(function () {
      return "".concat(isShowMore.value ? $t('button.fade') : $t('button.show')).concat($t('remaining')).concat(hideList.value.length, "\u4E2A");
    });
    var store = useStore();
    onMounted(function () {
      store.commit('setComponentNum', 1);
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, [_createTextVNode(_toDisplayString(__props.name) + " ", 1), __props.isSearch ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString(__props.list.length) + ")", 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(showList), function (item) {
        return _openBlock(), _createBlock(VideoBox, {
          query: __props.query,
          key: item.id,
          info: item
        }, null, 8, ["query", "info"]);
      }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(hideList), function (item) {
        return _withDirectives((_openBlock(), _createBlock(VideoBox, {
          key: item.id,
          info: item,
          query: __props.query
        }, null, 8, ["info", "query"])), [[_vShow, isShowMore.value]]);
      }), 128))]), __props.list.length > 6 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "show-more",
        onClick: handleShowMore
      }, [_createTextVNode(_toDisplayString(_unref(showMoreText)) + " ", 1), _createElementVNode("i", {
        class: _normalizeClass(["iconfont", isShowMore.value ? 'icon-sanjiao2' : 'icon-sanjiao1'])
      }, null, 2)])) : _createCommentVNode("", true)]);
    };
  }
};